module.exports = __webpack_public_path__ + "img/n_cj_page_bg.188b8b31.png";